/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentPeopleQueryResponse,
  GetApiV1IndividualpaymentPeopleQueryParams,
  GetApiV1IndividualpaymentPeople401,
  GetApiV1IndividualpaymentPeople500,
} from "../../types/individualPaymentController/GetApiV1IndividualpaymentPeople.ts";

function getGetApiV1IndividualpaymentPeopleUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/people` as const,
  };
  return res;
}

/**
 * @description Retorna pessoas com matrícula, filtradas por ids de pessoa, nome, e-mail, RA, CPF, CPF/CNPJ de terceiro, nosso número, nota fiscal, turma, empresa e método de pagamento (grupo boleto ou cartão). A empresa do usuário autenticado sobrepõe o parâmetro 'companyId'. Migrado do legado IndividualPayment/LoadGridDataAsyncPeople. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista paginada de pessoas da tela de pagamento individual (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/people}
 */
export async function getApiV1IndividualpaymentPeople(
  params?: GetApiV1IndividualpaymentPeopleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentPeopleQueryResponse,
    ResponseErrorConfig<
      GetApiV1IndividualpaymentPeople401 | GetApiV1IndividualpaymentPeople500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentPeopleUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
